import React from 'react';
import  makeStyles  from '@material-ui/core/styles/makeStyles';
import { CustomLabel,CustomButton }  from "@tracknme/material-ui";
import { FormControl } from '@material-ui/core';
import DoubleArrow from '@material-ui/icons/DoubleArrow';

const useStyles = makeStyles((theme) => ({
    modal: {
      backgroundColor:"#FFFFFF",
      width:256,
      height:124,
      display: 'flex',
      flexDirection:"column",
      overflow: 'hidden',
      outline:'none',
      borderRadius:10
    },
    hedear: {
      backgroundColor: "#FFFFFF",
      width:256,
      height:24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      borderTopLeftRadius:10,
      borderTopRightRadius:10
    },
    body: {
      backgroundColor: "#FFFFFF",
      width:256,
      height:100,
      borderBottomLeftRadius:10,
      borderBottomRightRadius:10
    },
  }));

  function changeButtonClose (){

     var baseURL = 'https://dev.tracknme.com.br/erp/login'
      if(window.location.href.indexOf("dev.") === -1){
          baseURL = 'https://www.tracknme.com.br/erp/login';
      }
  
    window.open(baseURL);
  }

function TipDashboard() {

    const classes = useStyles();

    return (
       
           
            <div className="demoVideo">
                
                <div className={classes.paper} >
                <div className={classes.hedear}>
                    <CustomLabel id="standard-basic-data-picker" label="Pronto para iniciar a configuração da sua plataforma?" color="initial" component="h6" variant="h6" style={{fontSize:14, fontWeight:700, color:'#4D39E9',marginTop:25, marginLeft:8}} />  
                </div>
                <div className={classes.body} style={{flexDirection:"row"}}> 
                
                  <FormControl className="m-8 mb-16 flex-1 "  disabled={false} >
                    <CustomButton id="button" disabled={false} onClick={() => changeButtonClose()} variant="contained" color="secondary" label="Acessar Dashboard" style={{marginLeft:12, marginTop:35}} endIcon={<DoubleArrow/>}  /> 
                  </FormControl> 
                </div>
                </div>
            </div>
    
      )
}
  
export default TipDashboard;
